import { render, staticRenderFns } from "./VehicleLayouts.vue?vue&type=template&id=c3a54b06&scoped=true"
import script from "./VehicleLayouts.vue?vue&type=script&lang=js"
export * from "./VehicleLayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a54b06",
  null
  
)

export default component.exports